import React from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import Layout from '../../components/Layout';
import { SetSelector } from './components/SetSelector';
import { QuizCard } from './components/QuizCard';
import { SvenTutorPage } from './components/SvenTutorPage';
import TranslateIcon from '@mui/icons-material/Translate';
import SchoolIcon from '@mui/icons-material/School';

export const Languages: React.FC = () => {
  const [selectedSetId, setSelectedSetId] = React.useState<number | null>(null);
  const [activeTab, setActiveTab] = React.useState<'vocab' | 'tutor'>('vocab');

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Banner/Header */}
        <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, gap: 2 }}>
          <Box>
            <Typography variant="h3" sx={{ fontWeight: 'black', color: 'primary.main', tracking: -1, mb: 1 }}>
              Svenska Ordbok
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Master Swedish vocabulary or practice Swedish dialogue with your AI tutor Sven!
            </Typography>
          </Box>

          {/* Tab Switcher - only show if not actively inside a quiz set */}
          {selectedSetId === null && (
            <Tabs
              value={activeTab}
              onChange={(_e, val) => setActiveTab(val)}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                width: { xs: '100%', sm: 'auto' },
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 3,
                p: 0.5,
                backgroundColor: 'background.paper',
                '& .MuiTabs-indicator': {
                  borderRadius: 2,
                  height: '100%',
                  opacity: 0.15,
                },
                '& .MuiTabs-flexContainer': {
                  flexWrap: { xs: 'nowrap', sm: 'nowrap' },
                }
              }}
            >
              <Tab
                value="vocab"
                label="Vocabulary Builder"
                icon={<SchoolIcon />}
                iconPosition="start"
                sx={{ minHeight: 'auto', fontWeight: 'bold', borderRadius: 2, textTransform: 'none' }}
              />
              <Tab
                value="tutor"
                label="Sven AI Tutor"
                icon={<TranslateIcon />}
                iconPosition="start"
                sx={{ minHeight: 'auto', fontWeight: 'bold', borderRadius: 2, textTransform: 'none' }}
              />
            </Tabs>
          )}
        </Box>

        {activeTab === 'tutor' && selectedSetId === null ? (
          <SvenTutorPage />
        ) : selectedSetId === null ? (
          <SetSelector onSelectSet={setSelectedSetId} />
        ) : (
          <QuizCard
            setId={selectedSetId}
            onBack={() => setSelectedSetId(null)}
          />
        )}
      </Container>
    </Layout>
  );
};

export default Languages;
